import { BrowserRouter, Routes, Route } from "react-router-dom";
import About from "./pages/About";
import Contact from "./pages/Contact";
import HomeFour from "./pages/HomeFour";
import Service from "./pages/Service";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import ScrollToTop from "react-scroll-to-top";
import Application from "./pages/Application";
import IndustrialElbow from "./pages/IndustrialElbow";
import IndustrialTee from "./pages/IndustrialTee";
function App() {
  useEffect(() => {
    AOS.init({
      offset: 0,
      easing: "ease",
      once: true,
    });
    AOS.refresh();
  }, []);
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path='/' element={<HomeFour />} />
        <Route path='/about' element={<About />} />
        <Route path='/application' element={<Application />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/products' element={<Service />} />
        <Route path="/products/industrial-elbow" element={<IndustrialElbow />} />
        <Route path="/products/industrial-tee" element={<IndustrialTee />} />
      </Routes>
      <ScrollToTop smooth color='#246BFD' />
    </BrowserRouter>
  );
}

export default App;
